module.exports = __webpack_public_path__ + "static/media/Cough – 1.282c0931.jpg";